import React, { useEffect, useLayoutEffect, useState } from "react";
import { CONSTANTS } from "../../../../constants";
import { CareTeamResultInterface } from "../../StatusBoard.model";
import AddDeletePopup from "../StatusBoardAddDeletePopup/StatusBoardAddDeletePopup";
import "./CareTeam.scss";
import classNames from "classnames/bind";
import { rolePermissionsService } from "../../../../services/rolePermissions.service";
import { utilService } from "../../../../services/utilService";
import _ from "lodash";
import { IonPopover } from "@ionic/react";
import { statusBoardService } from "../../StatusBoard.service";

import { useTranslation } from "react-i18next";

interface CareTeamProps {
  statusBoardData: any;
  updateTableData: () => void;
  statusBoardId: any;
}

const CareTeam: React.FC<CareTeamProps> = (props) => {
  const { t } = useTranslation("statusBoard");
  const iconList: any = CONSTANTS.CARE_TEAM_CATEGORY;
  const [showPopup, setAddDeletePopup] = useState(false);
  const rolePermissionData = rolePermissionsService.getRolePermissionsDetails();
  const [displayedButtonList, setDisplayedButtonList] = useState([]);
  const [hiddenButtonList, setHiddenButtonList] = useState([]);
  const [isMoreRequired, setIsMoreRequired] = useState(false);
  const [statusBoardName, setStatusBoardName] = useState("");
  const [popoverState, setShowPopover] = useState({
    showPopover: false,
    event: undefined,
  });

  const [selectedCareTeam, setSelectedCareTeam] = useState<any>(undefined);

  // Deselect  the careTeam after the notificaion has been  sent successfully
  useLayoutEffect(() => {
    let subscription = statusBoardService.clearCareTeamSelected.subscribe(
      (status: any) => {
        if (status) {
          setSelectedCareTeam(undefined);
          statusBoardService.selectedCareTeam = undefined;
        }
      }
    );
    return () => {
      subscription.unsubscribe();
    };
  }, []);

  useLayoutEffect(() => {
    statusBoardService.sbCareTeamStaffUpdated.subscribe((res: any) => {
      if (
        res &&
        res.data &&
        res.socketType === CONSTANTS.SOCKET_TYPE.CARE_TEAM_LIST
      ) {
        setDisplayedButtonList(res.data);
        setTimeout(() => {
          setIsMoreRequired(false);
          setDataList(res.data);
        }, 500);
      }
    });
  }, []);

  const showAddDeletePopup = () => {
    setSelectedCareTeam(undefined);
    statusBoardService.selectedCareTeam = undefined;
    setAddDeletePopup(true);
  };

  const refreshData = (data: any) => {
    if (data) {
      setHiddenButtonList([]);
      setDisplayedButtonList(data);
      setTimeout(() => {
        setIsMoreRequired(false);
        setDataList(data);
      }, 500);
    }
    setAddDeletePopup(false);
  };

  useEffect(() => {
    if (props.statusBoardData && props.statusBoardData.length !== 0) {
      const currentList = [...displayedButtonList, ...hiddenButtonList];
      const incomingList = props.statusBoardData[0]?.careTeam
        ? props.statusBoardData[0]?.careTeam
        : [];
      if (!_.isEqual(currentList, incomingList)) {
        updateCareTeamList(props.statusBoardData);
      }

      if (
        !_.isEqual(
          statusBoardName,
          props?.statusBoardData[0]?.statusBoardData?.name
        )
      ) {
        setStatusBoardName(props?.statusBoardData[0]?.statusBoardData?.name);
      }
    }
  }, [props.statusBoardData]);

  const updateCareTeamList = (statusBoardData: any) => {
    setDisplayedButtonList(
      statusBoardData[0]?.careTeam ? statusBoardData[0]?.careTeam : []
    );
    setTimeout(() => {
      setIsMoreRequired(false);
      setDataList(
        statusBoardData[0]?.careTeam ? statusBoardData[0]?.careTeam : []
      );
    }, 500);
  };

  const setDataList = (careTeamList: any) => {
    const cardPadding = 30;
    const buttonRow = document.getElementById("buttonRows");
    if (buttonRow && buttonRow?.children && buttonRow?.children.length > 0) {
      const dataSet = utilService.updateDisplayButtonList(
        buttonRow,
        _.cloneDeep(careTeamList),
        cardPadding,
        CONSTANTS.STATUS_BOARD_ROWTYPE.CARE_TEAM
      );
      const displayedButtonLists =
        !utilService.isEmpty(dataSet) && dataSet.displayedButtonList?.length
          ? dataSet.displayedButtonList
          : [];
      if (displayedButtonLists && displayedButtonLists.length) {
        setDisplayedButtonList(displayedButtonLists);
      }
      const hiddenButtonLists =
        dataSet && dataSet.hiddenButtonList ? dataSet.hiddenButtonList : [];
      if (hiddenButtonLists && hiddenButtonLists.length) {
        setHiddenButtonList(hiddenButtonLists);
      }
      const isMoreRequire =
        dataSet && dataSet.isMoreRequired ? dataSet.isMoreRequired : false;
      setIsMoreRequired(isMoreRequire);
    }
  };

  const onCareTeamClick = (selectedCareTeam: any) => {
    let careTeamAlertPermission = rolePermissionData?.notifyCareTeam;
    if (careTeamAlertPermission) {
      statusBoardService.selectedCareTeam = selectedCareTeam;
      setSelectedCareTeam(selectedCareTeam);
      if (
        statusBoardService?.selectedRowId &&
        statusBoardService?.rowData?.pid !== " "
      ) {
        statusBoardService.sendCareTeamNotification(true);
      }
    }
  };
  const showCareTeamListPopover = (event: any) => {
    event.persist();
    setShowPopover({ showPopover: true, event: event });
    setSelectedCareTeam(undefined);
    statusBoardService.selectedCareTeam = undefined;
  };

  return (
    <div className="care-team-container">
      <div className="sboard-name-header">{statusBoardName}</div>
      <div className="care-team-list-container">
        <div className="list-container-width" id="buttonRows">
          <div className="care-team-button-card 1">
            {displayedButtonList && displayedButtonList.length > 0 ? (
              displayedButtonList.map(
                (item: CareTeamResultInterface, index: number) => {
                  return (
                    <div
                      className={classNames({
                        "care-team-button-container": true,
                        "selected-care-team":
                          selectedCareTeam && selectedCareTeam.id === item.id,
                        "disable-buton":
                          statusBoardService?.rowData?.pid === " " &&
                          statusBoardService?.selectedRowId
                            ? true
                            : false,
                      })}
                      key={index}
                      onClick={() => onCareTeamClick(item)}
                    >
                      <div
                        className={`icon-div ${
                          iconList.CATEGORY[item?.category]
                        }`}
                      ></div>

                      <div className="item-name">{item.name}</div>
                    </div>
                  );
                }
              )
            ) : (
              <div
                onClick={showAddDeletePopup}
                className={classNames({
                  "no-list-btn": true,
                  "disable-buton": !rolePermissionData?.addCareTeam,
                })}
              >
                <span className="icon-add controller mr-2"></span>
                <span className="no-data-text"> {t("addCareTeam")}</span>
              </div>
            )}
          </div>
        </div>

        <div className="careteam-controller-div">
          {isMoreRequired && (
            <div
              className="icon-menu controller"
              onClick={(event: any) => {
                showCareTeamListPopover(event);
              }}
            ></div>
          )}
          {displayedButtonList && displayedButtonList.length > 0 && (
            <div
              className={classNames({
                "icon-add": true,
                controller: true,
                "disable-buton": !rolePermissionData?.addCareTeam,
              })}
              onClick={showAddDeletePopup}
            ></div>
          )}
        </div>
        <IonPopover
          className="popover-list-cont"
          event={popoverState.event}
          isOpen={popoverState.showPopover}
          showBackdrop={false}
          onDidDismiss={() =>
            setShowPopover({ showPopover: false, event: undefined })
          }
        >
          <div className="care-team-button-card 2">
            {hiddenButtonList && hiddenButtonList.length > 0
              ? hiddenButtonList.map(
                  (item: CareTeamResultInterface, index: number) => {
                    return (
                      <div
                        key={index}
                        onClick={() => onCareTeamClick(item)}
                        className={classNames({
                          "care-team-button-container": true,
                          "selected-care-team":
                            selectedCareTeam && selectedCareTeam.id === item.id
                              ? true
                              : false,
                        })}
                      >
                        <div
                          className={`icon-div ${
                            iconList.CATEGORY[item?.category]
                          }`}
                        ></div>

                        <div className="item-name">{item.name}</div>
                      </div>
                    );
                  }
                )
              : ""}
          </div>
        </IonPopover>
      </div>
      {showPopup && (
        <AddDeletePopup
          careTeamList={[...displayedButtonList, ...hiddenButtonList]}
          showModal={showPopup}
          popUpType={CONSTANTS.STATUS_BOARD_ROWTYPE.CARE_TEAM}
          statusBoardId={props.statusBoardId}
          onCancel={refreshData}
        ></AddDeletePopup>
      )}
    </div>
  );
};

export default CareTeam;
